'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _propTypes3 = require('utils/prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormRow = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(FormRow, _PureComponent);

  function FormRow() {
    (0, _classCallCheck3.default)(this, FormRow);
    return (0, _possibleConstructorReturn3.default)(this, (FormRow.__proto__ || (0, _getPrototypeOf2.default)(FormRow)).apply(this, arguments));
  }

  (0, _createClass3.default)(FormRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          title = _props.title,
          hint = _props.hint,
          titleClass = _props.titleClass,
          fieldClass = _props.fieldClass,
          hintClass = _props.hintClass,
          isRequired = _props.isRequired;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)('formRow', className) },
        title && _react2.default.createElement(
          'div',
          { className: titleClass },
          title,
          isRequired ? '*' : ''
        ),
        _react2.default.createElement(
          'div',
          { className: fieldClass },
          children
        ),
        hint && _react2.default.createElement(
          'div',
          { className: hintClass },
          hint
        )
      );
    }
  }]);
  return FormRow;
}(_react.PureComponent), _class.propTypes = {
  children: _propTypes3.nodes,
  className: _propTypes2.default.string,
  fieldClass: _propTypes2.default.string,
  hint: _propTypes3.nodes,
  hintClass: _propTypes2.default.string,
  isRequired: _propTypes2.default.bool,
  title: _propTypes3.nodes,
  titleClass: _propTypes2.default.string
}, _temp);
exports.default = FormRow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FormRow/FormRow.js
// module id = 2011
// module chunks = 1